import React, { useContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { PermissoesSidebarContext } from '../../Context/permissoesSidebar';

const ROTA_PARA_PERMISSAO = {
  '/dashboard': { tela: 'DASHBOARD', bloco: 'DASHBOARD' },
  '/listaUsuario': { tela: 'CADASTROS_USUARIOS', bloco: 'CADASTROS' },
  '/novoUsuario': { tela: 'CADASTROS_USUARIOS', bloco: 'CADASTROS' },
  '/sistemas': { tela: 'CADASTROS_SISTEMAS', bloco: 'CADASTROS' },
  '/novoSistema': { tela: 'CADASTROS_SISTEMAS', bloco: 'CADASTROS' },
  '/equipamentos': { tela: 'CADASTROS_EQUIPAMENTOS', bloco: 'CADASTROS' },
  '/novoEquipamento': { tela: 'CADASTROS_EQUIPAMENTOS', bloco: 'CADASTROS' },
  '/cadastro-categorias': { tela: 'CADASTROS_CATEGORIAS', bloco: 'CADASTROS' },
  '/cadastro-tipos-chamado': { tela: 'CADASTROS_TIPOS_CHAMADO', bloco: 'CADASTROS' },
  '/cadastro-status-chamado': { tela: 'CADASTROS_STATUS_CHAMADO', bloco: 'CADASTROS' },
  '/cadastro-grupos-usuario': { tela: 'CADASTROS_GRUPOS_USUARIO', bloco: 'CADASTROS' },
  '/cadastro-chamados-automaticos': { tela: 'CADASTROS_CHAMADOS_AUTOMATICOS', bloco: 'CADASTROS' },
  '/base-rag': { tela: 'CADASTROS_BASE_IA', bloco: 'CADASTROS' },
  '/config-empresa': { tela: 'CADASTROS_CONFIG_EMPRESA', bloco: 'CADASTROS' },
  '/listaHardware': { tela: 'INVENTARIO_HARDWARE', bloco: 'INVENTARIO' },
  '/novoHardware': { tela: 'INVENTARIO_HARDWARE', bloco: 'INVENTARIO' },
  '/novoVinculo': { tela: 'INVENTARIO_VINCULACAO', bloco: 'INVENTARIO' },
  '/novoDesvinculo': { tela: 'INVENTARIO_DESVINCULAR', bloco: 'INVENTARIO' },
  '/hardwaresUsuario': { tela: 'INVENTARIO_HARDWARE', bloco: 'INVENTARIO' },
  '/novoHisHar': { tela: 'MANUTENCAO_DOCUMENTAR', bloco: 'INVENTARIO' },
  '/listaHisHar': { tela: 'MANUTENCAO_HISTORICO', bloco: 'INVENTARIO' },
  '/novaSati': { tela: 'CHAMADOS_NOVO', bloco: 'CHAMADOS' },
  '/home': { tela: 'CHAMADOS_ABERTOS', bloco: 'CHAMADOS' },
  '/satiFechada': { tela: 'CHAMADOS_HISTORICO', bloco: 'CHAMADOS' },
  '/sprint': { tela: 'CHAMADOS_SPRINT', bloco: 'CHAMADOS' },
  '/repositorios': { tela: 'REPOSITORIOS_LISTA', bloco: 'REPOSITORIOS' },
  '/automacoes': { tela: 'AUTOMACAO', bloco: 'CONFIG' },
  '/webhooks': { tela: 'WEBHOOKS', bloco: 'CONFIG' },
  '/guia-configuracao': { tela: 'CONFIG_SISTEMA', bloco: 'CONFIG' },
  '/chaves-api': { tela: 'API_CHAVES', bloco: 'CONFIG' },
  '/politicas-sla': { tela: 'SLA', bloco: 'CONFIG' },
  '/timesheet': { tela: 'WORKLOG_TIMESHEET', bloco: 'WORKLOG' },
  '/faturamento': { tela: 'WORKLOG_FATURAMENTO', bloco: 'WORKLOG' },
  '/tarifas': { tela: 'WORKLOG_TARIFAS', bloco: 'WORKLOG' },
  '/relatorioColab': { tela: 'RELATORIOS_COLAB', bloco: 'RELATORIOS' },
  '/relatorioTipo': { tela: 'RELATORIOS_TIPO', bloco: 'RELATORIOS' },
  '/relatorioGeral': { tela: 'RELATORIOS_GERAL', bloco: 'RELATORIOS' },
  '/relatorioChamadosAberto': { tela: 'RELATORIOS_CHAMADOS_ABERTOS', bloco: 'RELATORIOS' },
  '/relatorioTempoColaborador': { tela: 'RELATORIOS_TEMPO_COLABORADOR', bloco: 'RELATORIOS' },
  '/relatorioEmpresa': { tela: 'RELATORIOS_EMPRESA', bloco: 'RELATORIOS' },
  '/paineis': { tela: 'RELATORIOS_PAINEIS', bloco: 'RELATORIOS' },
  '/empresas': { tela: 'ADMINISTRACAO_EMPRESAS', bloco: 'CONFIG' },
  '/configSistema': { tela: 'CONFIG_SISTEMA', bloco: 'CONFIG' },
  '/notificacoes': { tela: 'NOTIFICACOES', bloco: 'NOTIFICACOES' },
  '/ajuda': { tela: 'AJUDA', bloco: 'AJUDA' },
  '/permissoes-usuario': { tela: 'CONFIG_PERMISSOES_USUARIO', bloco: 'CONFIG' },
};

function pathnameToPermissao(pathname) {
  const path = pathname.split('?')[0];
  if (ROTA_PARA_PERMISSAO[path]) return ROTA_PARA_PERMISSAO[path];
  if (path.startsWith('/historicoSati/') || path === '/historicoSati') return { tela: 'CHAMADOS_ABERTOS', bloco: 'CHAMADOS' };
  if (path.startsWith('/historicoSatiFechada/') || path === '/historicoSatiFechada') return { tela: 'CHAMADOS_HISTORICO', bloco: 'CHAMADOS' };
  if (path.startsWith('/historicoDocumento/')) {
    const id = path.replace('/historicoDocumento/', '').split('/')[0];
    if (id === '1') return { tela: 'DOCUMENTACAO_INFRA', bloco: 'DOCUMENTACAO' };
    if (id === '3') return { tela: 'DOCUMENTACAO_SISTEMAS', bloco: 'DOCUMENTACAO' };
    return { tela: 'DOCUMENTACAO_PROCESSOS', bloco: 'DOCUMENTACAO' };
  }
  if (path.startsWith('/alterarDocumento')) return { tela: 'DOCUMENTACAO_INFRA', bloco: 'DOCUMENTACAO' };
  if (path.startsWith('/novoVinculo/')) return { tela: 'INVENTARIO_VINCULACAO', bloco: 'INVENTARIO' };
  if (path.startsWith('/novoDesvinculo/')) return { tela: 'INVENTARIO_DESVINCULAR', bloco: 'INVENTARIO' };
  if (path.startsWith('/hardware/')) return { tela: 'INVENTARIO_HARDWARE', bloco: 'INVENTARIO' };
  if (path.startsWith('/hardwaresUsuario/')) return { tela: 'INVENTARIO_HARDWARE', bloco: 'INVENTARIO' };
  if (path.startsWith('/novoHisHar/')) return { tela: 'MANUTENCAO_DOCUMENTAR', bloco: 'INVENTARIO' };
  if (path.startsWith('/listaHisHar/')) return { tela: 'MANUTENCAO_HISTORICO', bloco: 'INVENTARIO' };
  if (path.startsWith('/repositorios')) return { tela: 'REPOSITORIOS_LISTA', bloco: 'REPOSITORIOS' };
  if (path.startsWith('/sprint/')) return { tela: 'CHAMADOS_SPRINT', bloco: 'CHAMADOS' };
  if (path.startsWith('/permissoes-usuario')) return { tela: 'CONFIG_PERMISSOES_USUARIO', bloco: 'CONFIG' };
  return null;
}

function podeAcessar(permissoes, { tela, bloco }) {
  if (permissoes == null) return true;
  if (permissoes[tela] === true || permissoes[tela] === undefined) return true;

  if (tela === 'REPOSITORIOS_LISTA' && permissoes.REPOSITORIOS === true) return true;
  if (['WORKLOG_TIMESHEET', 'WORKLOG_FATURAMENTO', 'WORKLOG_TARIFAS'].includes(tela) && permissoes.WORKLOG === true) return true;
  if (tela === 'AUTOMACAO' && permissoes.CONFIG === true) return true;
  if (tela === 'WEBHOOKS' && permissoes.CONFIG === true) return true;
  if (tela === 'API_CHAVES' && permissoes.CONFIG === true) return true;
  if (tela === 'SLA' && permissoes.CONFIG === true) return true;

  if (tela === 'RELATORIOS_CHAMADOS_ABERTOS') {
    if (permissoes[tela] === false) return false;
    const temAlgumRelatorio = ['RELATORIOS', 'RELATORIOS_COLAB', 'RELATORIOS_TIPO', 'RELATORIOS_GERAL'].some((c) => permissoes[c] === true);
    if (temAlgumRelatorio) return true;
  }
  if (tela === 'RELATORIOS_TEMPO_COLABORADOR') {
    if (permissoes[tela] === false) return false;
    const temAlgumRelatorio = ['RELATORIOS', 'RELATORIOS_COLAB', 'RELATORIOS_TIPO', 'RELATORIOS_GERAL', 'RELATORIOS_CHAMADOS_ABERTOS'].some((c) => permissoes[c] === true);
    if (temAlgumRelatorio) return true;
  }
  if (tela === 'RELATORIOS_EMPRESA') {
    if (permissoes[tela] === false) return false;
    const temAlgumRelatorio = ['RELATORIOS', 'RELATORIOS_COLAB', 'RELATORIOS_TIPO', 'RELATORIOS_GERAL', 'RELATORIOS_CHAMADOS_ABERTOS', 'RELATORIOS_TEMPO_COLABORADOR'].some((c) => permissoes[c] === true);
    if (temAlgumRelatorio) return true;
  }
  if (tela === 'RELATORIOS_PAINEIS') {
    if (permissoes[tela] === false) return false;
    const temAlgumRelatorio = ['RELATORIOS', 'RELATORIOS_COLAB', 'RELATORIOS_TIPO', 'RELATORIOS_GERAL', 'RELATORIOS_CHAMADOS_ABERTOS', 'RELATORIOS_TEMPO_COLABORADOR', 'RELATORIOS_EMPRESA'].some((c) => permissoes[c] === true);
    if (temAlgumRelatorio) return true;
  }

  if (permissoes[tela] === false) return false;
  if (bloco && permissoes[bloco] === true) return true;
  return false;
}

const TELAS_ADMINISTRACAO = ['ADMINISTRACAO_EMPRESAS'];

export default function PermissaoRotaGuard({ children }) {
  const location = useLocation();
  const history = useHistory();
  const { permissoes, loading } = useContext(PermissoesSidebarContext);

  const permissaoRequerida = pathnameToPermissao(location.pathname);
  if (permissaoRequerida == null) return <>{children}</>;
  if (loading || permissoes == null) return <>{children}</>;
  if (TELAS_ADMINISTRACAO.includes(permissaoRequerida.tela)) {
    const empresaId = localStorage.getItem('empresa_id');
    if (String(empresaId) !== '1' && Number(empresaId) !== 1) {
      history.replace('/home');
      return null;
    }
  }
  if (!podeAcessar(permissoes, permissaoRequerida)) {
    history.replace('/home');
    return null;
  }
  return <>{children}</>;
}
